export const CEO_BRIEFING = {
  greeting: {
    date: 'Monday, Jan 27',
    meetings: 3,
    approvals: 3,
    lucMessage: "Hope the weekend treated you well! You've got a solid day ahead — 2 risks need early attention, but your pipeline is looking strong at 3.2x. I've lined everything up for you."
  },
  priorities: {
    mustDo: [
      {
        id: 'p1',
        title: 'Review Q1 GTM Strategy',
        agent: 'marsi',
        agentNote: 'Marsi drafted this',
        urgency: 'time-sensitive',
        description: 'Marsi has completed the Q1 go-to-market strategy focusing on PLG motion for the dev tools market.',
        expanded: {
          summary: 'The strategy targets SMB dev tool companies through a product-led growth motion, combining organic content with paid acquisition.',
          details: [
            { label: 'Target Market', value: 'SMB Dev Tools (50-200 employees)' },
            { label: 'Primary Channel', value: 'LinkedIn + Content Marketing' },
            { label: 'Budget Required', value: '$28,000 / quarter' },
            { label: 'Projected Pipeline', value: '120 qualified leads / month' },
            { label: 'Expected CAC', value: '$233 per lead' },
          ],
          artifacts: [
            { name: 'Q1 GTM Strategy Deck', type: 'pdf' },
            { name: 'Channel Breakdown Model', type: 'spreadsheet' },
          ],
          thinking: 'Marsi analyzed 90 days of campaign data, benchmarked against 3 competitor strategies, and consulted Dora\'s market research on dev tool buyer behavior. PLG was chosen over outbound because our trial-to-paid conversion rate (18%) outperforms industry average (12%).'
        }
      },
      {
        id: 'p2',
        title: 'Revenue Forecast Review',
        agent: 'sally',
        agentNote: 'Sally updated projections',
        urgency: 'due-today',
        description: 'Sally has updated Q1 revenue projections based on current pipeline health and deal velocity.',
        expanded: {
          summary: 'Q1 forecast revised to $342K (down from $380K). Two enterprise deals slipped to Q2, but SMB pipeline is stronger than projected.',
          details: [
            { label: 'Q1 Forecast', value: '$342,000 (was $380K)' },
            { label: 'Pipeline Coverage', value: '3.2x (healthy)' },
            { label: 'Deals at Risk', value: '2 enterprise ($38K total)' },
            { label: 'SMB Pipeline', value: '+22% above target' },
            { label: 'Win Rate (30d)', value: '34% (up from 28%)' },
          ],
          artifacts: [
            { name: 'Q1 Revenue Forecast', type: 'spreadsheet' },
            { name: 'Deal Risk Assessment', type: 'pdf' },
          ],
          thinking: 'Sally cross-referenced CRM data with Finn\'s cashflow model. The two slipped deals (TechCorp, DataFlow) both cited budget freeze — not product fit. SMB momentum is driven by the new pricing tier launched 3 weeks ago. Finn has already adjusted cashflow projections to reflect the revised forecast.'
        }
      },
      {
        id: 'p3',
        title: 'Resolve Support Capacity Risk',
        agent: 'zira',
        agentNote: 'Zira flagged this',
        urgency: 'critical',
        description: 'Support team is at 142% of SLA capacity. Stark recommends immediate triage to prevent customer churn.',
        expanded: {
          summary: 'Support ticket volume spiked 40% after the v2.3 release. Current team of 4 cannot maintain SLA targets. Zira has identified 23 tickets at risk of SLA breach today.',
          details: [
            { label: 'Current Load', value: '142% of SLA capacity' },
            { label: 'Tickets at Risk', value: '23 (SLA breach by EOD)' },
            { label: 'Root Cause', value: 'v2.3 release — 3 known issues' },
            { label: 'Avg Response Time', value: '4.2hrs (SLA: 2hrs)' },
            { label: 'Churn Risk Accounts', value: '5 flagged by Zira' },
          ],
          artifacts: [
            { name: 'Support Load Analysis', type: 'pdf' },
            { name: 'Churn Risk Report', type: 'spreadsheet' },
          ],
          thinking: 'Stark analyzed ticket inflow patterns post-release and cross-referenced with Zira\'s SLA tracking. The 3 known issues account for 68% of new tickets. Stark recommends: (1) Publish a known-issues page to reduce inbound, (2) Temporarily reassign 1 team member from QA, (3) Prioritize fixes for the top 2 issues in next sprint. Estimated resolution: 3 days.',
          proposedActions: [
            { label: 'Publish known-issues page', department: 'Support', agent: 'Zira' },
            { label: 'Reassign QA resource temporarily', department: 'People', agent: 'Tali' },
            { label: 'Prioritize bug fixes in sprint', department: 'Engineering', agent: 'Stark' },
          ]
        }
      }
    ],
    shouldDo: [
      {
        id: 'p4',
        title: 'Review hiring pipeline for engineering',
        agent: 'tali',
        agentNote: 'Tali update',
        description: '3 candidates in final round for Senior Developer role. Tali recommends moving to offer stage for 2.'
      },
      {
        id: 'p5',
        title: 'Weekly team sync prep',
        agent: 'luc',
        agentNote: 'Luc compiled this',
        description: 'Talking points compiled from this week\'s cross-department activity. 12 min read.'
      }
    ]
  },
  approvals: [
    {
      id: 'a1',
      title: 'Meta Campaign: Brand Awareness Push',
      agent: 'marsi',
      agentNote: 'Marsi requests approval',
      type: 'Campaign Budget',
      amount: '$5,000',
      expanded: {
        summary: 'Marsi has built a 3-week Meta campaign targeting SMB founders in the dev tools space. Campaign is in draft mode on Meta — nothing published.',
        details: [
          { label: 'Budget', value: '$5,000 (3 weeks)' },
          { label: 'Target Audience', value: 'SMB founders, Dev Tools, US/EU' },
          { label: 'Projected Reach', value: '45,000 impressions' },
          { label: 'Expected CTR', value: '2.8% (based on past campaigns)' },
          { label: 'Estimated Leads', value: '35-50 demo bookings' },
          { label: 'Cost per Lead', value: '$100-143' },
        ],
        artifacts: [
          { name: 'Campaign Brief', type: 'pdf' },
          { name: 'Ad Creative Drafts', type: 'image' },
          { name: 'Audience Targeting Config', type: 'pdf' },
        ],
        thinking: 'Marsi analyzed the last 4 Meta campaigns. The "founder persona" targeting consistently outperforms generic B2B targeting by 2.4x on CTR. Budget is conservative — previous $8K campaign generated 62 bookings. Wright has reviewed all copy for brand consistency.'
      }
    },
    {
      id: 'a2',
      title: 'Acme Corp Proposal',
      agent: 'sally',
      agentNote: 'Sally needs sign-off',
      type: 'Deal Proposal',
      amount: '$48,000',
      expanded: {
        summary: 'Enterprise deal with Acme Corp for annual platform license. Sally has built the proposal using CRM data, 3 meeting summaries, and competitive intel from Dora.',
        details: [
          { label: 'Deal Value', value: '$48,000 / year' },
          { label: 'Client', value: 'Acme Corp (Series B, 120 employees)' },
          { label: 'Champion', value: 'VP Ops — Sarah Kim' },
          { label: 'Win Probability', value: '72%' },
          { label: 'Competitor', value: 'AgentHub (quoted $52K)' },
          { label: 'Pricing', value: '12% below competitor' },
        ],
        artifacts: [
          { name: 'Full Proposal Document', type: 'pdf' },
          { name: 'Pricing Breakdown', type: 'spreadsheet' },
          { name: 'Competitive Analysis', type: 'pdf' },
        ],
        thinking: 'Sally generated pricing using the deterministic model — not LLM-estimated. Margin is 68% at this price point. Dora\'s competitive research shows AgentHub quoted $52K but lacks our workflow automation depth. The 12% discount is justified by Acme\'s potential for expansion (3 departments interested). Similar deals closed at 81% win rate.'
      }
    },
    {
      id: 'a3',
      title: 'Senior Developer Requisition',
      agent: 'tali',
      agentNote: 'Tali requests approval',
      type: 'Hiring',
      amount: '$135K-155K',
      expanded: {
        summary: 'Engineering team at 92% capacity with 3 projects queued for Q2. Tali recommends opening a Senior Developer role immediately to avoid delivery delays.',
        details: [
          { label: 'Role', value: 'Senior Developer (Full-stack)' },
          { label: 'Salary Range', value: '$135,000 - $155,000' },
          { label: 'Team Capacity', value: '92% (critical threshold)' },
          { label: 'Queued Projects', value: '3 for Q2' },
          { label: 'Time to Hire (est)', value: '4-6 weeks' },
          { label: 'Budget Impact', value: '+$12.5K/month' },
        ],
        artifacts: [
          { name: 'Job Description', type: 'pdf' },
          { name: 'Capacity Analysis', type: 'spreadsheet' },
          { name: 'Budget Impact Report', type: 'pdf' },
        ],
        thinking: 'Tali analyzed sprint velocity trends over 8 weeks — team throughput dropped 15% as complexity increased. Finn confirmed budget headroom for the hire. Wright has drafted the JD aligned with our employer brand. If approved today, Tali estimates first interviews within 2 weeks.'
      }
    }
  ],
  risks: [
    {
      id: 'r1',
      title: 'Lead quality dropped 18% this week',
      agents: ['stark', 'sally'],
      severity: 'high',
      description: 'Stark detected a significant drop in lead quality scores. Sally reports pipeline impact — conversion from MQL to SQL down from 24% to 18%.',
      expanded: {
        details: [
          { label: 'Lead Quality Score', value: 'Down 18% (7-day trend)' },
          { label: 'MQL → SQL Conversion', value: '18% (was 24%)' },
          { label: 'Root Cause', value: 'New content campaign attracting wrong persona' },
          { label: 'Pipeline Impact', value: '$45K in projected pipeline at risk' },
          { label: 'Affected Channels', value: 'LinkedIn Ads, Blog organic' },
        ],
        thinking: 'Stark cross-referenced Marsi\'s campaign attribution data with Sally\'s lead scoring model. The new "AI for Everyone" blog series is ranking well but attracting individual users, not SMB decision-makers. Recommends Marsi narrow targeting and Wright adjust content tone.',
        proposedActions: [
          { label: 'Narrow LinkedIn ad targeting to VP+ titles', department: 'Marketing', agent: 'Marsi' },
          { label: 'Adjust content strategy to SMB use cases', department: 'Marketing', agent: 'Wright' },
          { label: 'Re-score existing MQLs with updated criteria', department: 'Sales', agent: 'Sally' },
        ]
      }
    },
    {
      id: 'r2',
      title: 'Support backlog at 142% of SLA capacity',
      agents: ['stark', 'zira'],
      severity: 'critical',
      description: 'Support team overwhelmed after v2.3 release. 23 tickets at risk of SLA breach today. 5 accounts flagged for churn risk.',
      expanded: {
        details: [
          { label: 'Current Load', value: '142% of SLA capacity' },
          { label: 'Tickets at SLA Risk', value: '23 (breach by EOD)' },
          { label: 'Churn Risk Accounts', value: '5 (combined ARR: $89K)' },
          { label: 'Root Cause', value: 'v2.3 release — 3 known issues' },
          { label: 'Resolution ETA', value: '3 days (with proposed actions)' },
        ],
        thinking: 'Stark and Zira jointly analyzed the situation. 68% of new tickets trace to 3 specific bugs in v2.3. The 5 churn-risk accounts are all on annual plans renewing within 60 days. Zira has pre-drafted personalized responses for each. Estimated ARR at risk: $89K.',
        proposedActions: [
          { label: 'Publish known-issues status page', department: 'Support', agent: 'Zira' },
          { label: 'Send proactive outreach to 5 churn-risk accounts', department: 'Support', agent: 'Zira' },
          { label: 'Escalate top 2 bugs to engineering sprint', department: 'Engineering', agent: 'Stark' },
        ]
      }
    }
  ],
  meetings: [
    { id: 'm1', title: 'Q1 Planning Sync', time: '10:00 AM', duration: '30 min', with: 'Leadership Team', type: 'internal', agenda: ['Q1 revenue targets review', 'Marketing budget allocation', 'Hiring timeline for engineering team'] },
    { id: 'm2', title: 'Acme Corp Follow-up', time: '2:00 PM', duration: '45 min', with: 'Sarah Kim (Acme Corp)', type: 'external', agenda: ['Product demo walkthrough', 'Pricing discussion and negotiation', 'Implementation timeline review'] },
    { id: 'm3', title: 'Engineering Sprint Review', time: '4:00 PM', duration: '30 min', with: 'Engineering Team', type: 'internal', agenda: null },
  ],
  dailyTimeline: [
    { time: '9:00 AM', type: 'task', title: 'Review Q1 GTM Strategy', agent: 'marsi' },
    { time: '9:30 AM', type: 'task', title: 'Revenue Forecast Review', agent: 'sally' },
    { time: '10:00 AM', type: 'meeting', title: 'Q1 Planning Sync', duration: '30 min', with: 'Leadership Team' },
    { time: '11:00 AM', type: 'task', title: 'Resolve Support Capacity Risk', agent: 'stark' },
    { time: '12:00 PM', type: 'approval', title: 'Review & sign-off on pending approvals', count: 3 },
    { time: '2:00 PM', type: 'meeting', title: 'Acme Corp Follow-up', duration: '45 min', with: 'Sarah Kim (Acme Corp)' },
    { time: '4:00 PM', type: 'meeting', title: 'Engineering Sprint Review', duration: '30 min', with: 'Engineering Team' },
  ],
  inbox: [
    { id: 'cei1', sender: 'Vikram Rao (Board)', senderInitials: 'VR', time: '8:12 AM', summary: 'Requesting updated Q1 revenue projections for Friday\'s board prep call.', expandedSummary: 'Vikram is prepping the Q1 board deck and needs the latest revenue figures by Wednesday EOD. He wants the revised forecast ($342K), the deal slippage context, and the SMB offset narrative. Also requesting a brief note on the v2.3 support situation.', fullEmail: 'Hi Arjun,\n\nHope your Monday is off to a good start. I\'m putting together the Q1 board deck and need a few things from you by Wednesday EOD:\n\n1. Updated revenue forecast — I heard there were some deal slippages. What\'s the revised number and what\'s the story behind it?\n\n2. SMB pipeline update — Last I saw, this was tracking well. Any updated metrics I can include?\n\n3. v2.3 support situation — The board will ask. I\'d rather we get ahead of it with a clear narrative than have it come up as a surprise.\n\nI\'m aiming to have the deck finalized by Thursday afternoon so we can do a dry run before Friday.\n\nThanks,\nVikram' },
    { id: 'cei2', sender: 'Lisa Chen (DataFlow)', senderInitials: 'LC', time: '7:45 AM', summary: 'Confirming budget freeze but expressing continued interest for Q2.', expandedSummary: 'Lisa confirmed the internal freeze is company-wide and not related to Implify. She\'s asked to keep the proposal active and wants to schedule a check-in for late February to discuss Q2 timelines. Positive signal — she mentioned our product to their new VP of Engineering.', fullEmail: 'Hi Arjun,\n\nWanted to give you a quick update on our end. As you may have heard, we\'ve implemented a company-wide budget freeze through the end of Q1. I want to emphasize this has nothing to do with Implify — the timing is just unfortunate.\n\nThe good news: our new VP of Engineering, Marco, has been asking about workflow automation tools. I mentioned Implify and he was intrigued by the agent-based approach.\n\nCan we keep the proposal on the table and schedule a check-in for late February? I\'d love to bring Marco into the conversation for Q2 planning.\n\nBest,\nLisa' },
    { id: 'cei3', sender: 'Meera Rao (Frontend Lead)', senderInitials: 'MR', time: '7:30 AM', summary: 'Requesting PTO for Sprint 14 — Feb 10-21, flagging overlap with Raj\'s request.', expandedSummary: 'Meera submitted her PTO request and flagged that Raj also requested the same sprint off. She\'s flexible on shifting by a few days if needed but has family commitments Feb 14-17. Asking for a resolution by Wednesday so she can finalize travel plans.', fullEmail: 'Hey Arjun,\n\nI\'m submitting my PTO request for Sprint 14 (Feb 10-21). I know this is a long stretch, but I have a family commitment Feb 14-17 that I can\'t move.\n\nHeads up — I noticed Raj also requested time off during Sprint 14. If both of us being out is a problem, I\'m flexible on the other days (Feb 10-13 and Feb 18-21). The Feb 14-17 dates are the ones I really need.\n\nCould you let me know by Wednesday? I need to finalize flights and my parents are already asking about plans.\n\nThanks!\nMeera' },
    { id: 'cei4', sender: 'James Park (TechCorp CTO)', senderInitials: 'JP', time: 'Yesterday', summary: 'Escalating API integration issues — requesting a call with leadership.', expandedSummary: 'James is frustrated with the v2.3 API breakage impacting their production systems. He\'s requesting a call with "someone senior" to discuss the timeline for resolution and wants assurances this won\'t recur. His contract renewal is in 45 days — this needs careful handling.', fullEmail: 'Arjun,\n\nI need to escalate this directly. The v2.3 update broke our API integration and it\'s been impacting our production environment for 3 days now. My team has spent 40+ hours on workarounds.\n\nOur support contact has been helpful but I need to hear from someone in leadership:\n\n1. What exactly happened and why wasn\'t this caught in testing?\n2. When will this be fully resolved — not "we\'re working on it" but a specific date?\n3. What are you doing to ensure this doesn\'t happen again?\n\nI\'ll be candid — we have a renewal decision coming up in 45 days and this experience is weighing heavily on that conversation internally.\n\nI\'d appreciate a call this week.\n\nJames Park\nCTO, TechCorp' },
    { id: 'cei5', sender: 'Neel Kapoor (Finance)', senderInitials: 'NK', time: 'Yesterday', summary: 'Sharing updated 90-day cashflow model — needs your sign-off before board share.', expandedSummary: 'Neel has incorporated the revised Q1 forecast and the Senior Developer hire into the cashflow model. All three scenarios (low, mid, high) maintain runway above 6 months. He wants to align on the narrative before sharing with the board — specifically whether to flag the hire as "planned" or "under consideration."', fullEmail: 'Hi Arjun,\n\nAttached is the updated 90-day cashflow model incorporating:\n- Revised Q1 revenue forecast ($342K)\n- Senior Developer hire (assuming mid-range at $145K)\n- Current burn rate adjustments\n\nAll three scenarios maintain runway above 6 months, which is our board-mandated threshold.\n\nBefore I share with the board, I need your input on two narrative decisions:\n\n1. The Senior Dev hire — should I flag it as "planned" or "under consideration"? This changes the mid-scenario by ~$12.5K/month.\n\n2. The Q1 revenue revision — I\'m framing it as a timing adjustment rather than a demand signal. The SMB pipeline strength supports this. Agree?\n\nDeadline: Wednesday EOD for the board package.\n\nThanks,\nNeel' },
  ]
};
